<template>
    <div class="checkout-delivery">
        <!--        <span v-if="result.title">{{ result.title }}</span>-->

        <ul v-if="result.deliveries">
            <li v-for="delivery in result.deliveries">
                <label>
                    <!--TODO: не использовать $parent-->
                    <input class="def-radio"
                           @change="$emit('setAjax')"
                           type="radio"
                           name="DELIVERY_ID"
                           :value="delivery.ID"
                           :checked="delivery.CHECKED"
                    >
                    <span class="text">{{ delivery.NAME }}</span>
                </label>
                <SlideUpDown :modelValue="!!delivery.CHECKED">
                    <new-post-office
                        v-if="checkNewPost(delivery.ID) && delivery.CHECKED === 'Y'"
                        @change="$emit('setAjax')"
                        :result="getDataForNewPostOffice(delivery.ID)"
                    />

                    <ul v-else-if="result.properties && !!delivery.CHECKED" class="delivery">
                        <li v-for="prop in result.properties" :key="prop.ID" v-if="prop.PROPS_GROUP_ID == 2">
                            <div v-if="prop.TYPE === 'STRING' && prop.CODE !== 'COUNTRY_PHONE'">
                                <def-input
                                    :name="getName(prop)"
                                    v-model="prop.VALUE[0]"
                                    :label="prop.NAME"
                                    :required="prop.CODE !== 'APARTMENT'"
                                />
                            </div>
                            <div v-else-if="prop.TYPE !== 'STRING'">
                                ID: {{ prop.ID }}
                                Name: {{ prop.NAME }} <br>
                                Type: {{ prop.TYPE }}
                            </div>
                        </li>
                        <li>
                            <vue-select v-if="getSortedStoreList.length" :result="getSortedStoreList"
                                        :options="{...selectOption, default: getActiveStore}" style="width: 100%"
                                        @change="$emit('setAjax')"/>
                        </li>
                    </ul>

                </SlideUpDown>

            </li>
        </ul>
<!--        <div class="def-button" @click="$emit('changeStep', 3)">{{ result.messages.nextStep }}</div>-->
    </div>
</template>
<script>
export default {
    name: "checkout-delivery",
    props: ['result'],
    data() {
        return {
            selectOption: {
                name: 'BUYER_STORE',
                text: 'ADDRESS',
                value: 'ID',
            }
        }
    },
    methods: {
        getName: function (prop) {
            return 'ORDER_PROP_' + prop.ID;
        },
        getValue: function (prop) {
            return prop.VALUE[0];
        },
        getDataForNewPostOffice(id) {
            return {
                postCity: this.result?.properties?.find(prop => prop.CODE == 'CITY'),
                postOffice: this.result?.properties?.find(prop => prop.CODE == 'NP_DEPARTMENT'),
                deliveryRouts: this.result?.deliveryRouts?.[id],
            }
        },
        checkNewPost(id) {
            if (this.result?.deliveryRouts?.[id]?.type === 'NovaPoshta') {
                return true;
            }
            return false;
        }
    },
    computed: {
        getSortedStoreList() {
            try {
                const {STORE_LIST} = this.result;
                const deliveriesFilter = Object.values(this.result.deliveries)
                    .filter(delivery => delivery.CHECKED === 'Y')[0].STORE;
                return Object.values(STORE_LIST).filter(store => deliveriesFilter.find(el => store.ID == el));
            } catch (err) {
                console.error(err);
                return [];
            }
        },
        getActiveStore() {
            const {BUYER_STORE, STORE_LIST} = this.result;
            if (STORE_LIST[BUYER_STORE]) {
                const {ADDRESS: text, ID: value} = STORE_LIST[BUYER_STORE];
                return {text, value};
            }
        },
    },
    mounted() {
        // if (this.$parent.debug) {
        //     console.log(this.result);
        // }
        // console.log(this.getDataForNewPostOffice);
    }
}
</script>

<style lang="scss" scoped>
.checkout-delivery {
    width: 100%;
    @include point-md {
        max-width: 356px;
    }
    @include point-lg {
        max-width: 400px;
    }
}

.delivery {
    margin-bottom: 16px;
}

.def-input {
    width: 100%;
}
</style>